<!--
 * @Author: Jone
 * @Date: 2022年4月28日14:07:23
 * @LastEditors: Jone
 * @LastEditTime: 2022-03-18 21:16:48
 * @FilePath: /frontend/lib/MetaData.vue
 * @Description:
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
-->
<template>
  <div class="height100">
    <md-main-wrap ref="meta-data" />
  </div>
</template>
<script>
import { t as lang } from './locale/index.js'
import { initOptions } from './common/options'

export default {
  name: 'MetaData',
  watch: {
    $OecpMetaDataConfig: {
      handler: function (cfg) {},
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      lang,
    }
  },
  created() {
    let that = this
    initOptions.call(this)
    this.$OecpMetaDataEventBus.$on('customEvent', function (eventName, ...arg) {
      that.$emit(eventName, ...arg)
    })
  },
}
</script>
<style scoped>
.height100 {
  height: 100%;
  flex: 1;
  overflow: auto;
}
</style>
